import * as pinModeUtils_deprecated from './pinModeUtils_deprecated';

/**
 * @deprecated use `@/pinModeUtils` instead
 */
export const pinModeUtils = pinModeUtils_deprecated;
